import React, { useState, useEffect, useContext } from 'react';
import './Header.css'; // Ensure this file exists and is correctly linked
import logo from '../static/assets/logo.png'; // Adjust path as necessary
import { ModalContext } from '../App';
import { Phone, Calculator } from 'lucide-react'; // Import icons from lucide-react

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isSticky, setSticky] = useState(false);
  const [, setIsMobileView] = useState(window.innerWidth < 950);
  const [isTabletView, setIsTabletView] = useState(window.innerWidth < 1250);
  const { openModal } = useContext(ModalContext);

  const handleScroll = () => {
    setSticky(window.scrollY > 50);
  };

  const handleResize = () => {
    setIsMobileView(window.innerWidth < 950);
    setIsTabletView(window.innerWidth < 1250);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleResize);

    // Cleanup function to remove the event listeners
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <header className={`header ${isSticky ? 'sticky' : ''}`}>
      <div className="logo-container-header">
        <a href='/' className="logo-link">
          <img alt='Logo' src={logo} className="logo-img-header" />
        </a>
        {!isTabletView && <span className="logo-text">Escudero Electrical Contractors LLC</span>}
      </div>
      <nav className={isOpen ? "nav open" : "nav"}>
        <ul>
          <li><a href="/about" onClick={() => setIsOpen(false)}>About Us</a></li>
          <li><a href="/services" onClick={() => setIsOpen(false)}>Services</a></li>
          <li><a href="/social-media" onClick={() => setIsOpen(false)}>Social Media</a></li>
          <li><a href="/contact" onClick={() => setIsOpen(false)}>Contact Us</a></li>
        </ul>
        <button className="close-btn" onClick={() => setIsOpen(false)}>X</button>
      </nav>
      <div className="header-buttons-container">
        <a href="tel:+12244096234" className="call-button">
          <Phone size={16} className="button-icon" /> Call Us
        </a>
        <button onClick={openModal} className="quote-button-header">
          <Calculator size={16} className="button-icon" /> Get a Quote
        </button>
      </div>
      <div className="menu-icon" onClick={() => setIsOpen(!isOpen)}>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </header>
  );
};

export default Header;